<main class="main-page">
	<app-spinner></app-spinner>
	<div class="section-container page-layout">
		<div class="main-content">
			<router-outlet></router-outlet>
		</div>
	</div>
</main>